
<section class="flex flex-col w-full h-full">
  <iframe class="h-full" [appIframeData] [attr.src]="simonLifeCyclePolicyIframeUrl | safeUrl" safe frameborder="0"></iframe>
</section>